import { ShopItem } from '@/types/shop';

// =============================================
// FREE AVATARS (4 only - starter pack)
// =============================================
export const FREE_AVATARS = ['🦁', '🐼', '🦊', '🐰'];

// =============================================
// PREMIUM AVATARS (Purchasable with points)
// =============================================
export const PREMIUM_AVATARS: ShopItem[] = [
  // Basic Animals (Level 1+, 25 pts)
  { id: 'tiger', type: 'avatar', name: 'Tiger', emoji: '🐯', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'koala', type: 'avatar', name: 'Koala', emoji: '🐨', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'pig', type: 'avatar', name: 'Pig', emoji: '🐷', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'cat', type: 'avatar', name: 'Cat', emoji: '🐱', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'dog', type: 'avatar', name: 'Dog', emoji: '🐶', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'butterfly', type: 'avatar', name: 'Butterfly', emoji: '🦋', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'frog', type: 'avatar', name: 'Frog', emoji: '🐸', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  { id: 'unicorn', type: 'avatar', name: 'Unicorn', emoji: '🦄', cost: 25, requiredLevel: 1, category: 'Basic Animals' },
  
  // Food Fun (Level 1+, 30 pts)
  { id: 'pizza', type: 'avatar', name: 'Pizza', emoji: '🍕', cost: 30, requiredLevel: 1, category: 'Food Fun' },
  { id: 'cupcake', type: 'avatar', name: 'Cupcake', emoji: '🧁', cost: 30, requiredLevel: 1, category: 'Food Fun' },
  { id: 'icecream', type: 'avatar', name: 'Ice Cream', emoji: '🍦', cost: 30, requiredLevel: 1, category: 'Food Fun' },
  { id: 'donut', type: 'avatar', name: 'Donut', emoji: '🍩', cost: 30, requiredLevel: 1, category: 'Food Fun' },
  
  // Space (Level 2+, 40 pts)
  { id: 'alien', type: 'avatar', name: 'Alien', emoji: '👽', cost: 40, requiredLevel: 2, category: 'Space' },
  { id: 'rocket', type: 'avatar', name: 'Rocket', emoji: '🚀', cost: 40, requiredLevel: 2, category: 'Space' },
  { id: 'star', type: 'avatar', name: 'Star', emoji: '⭐', cost: 40, requiredLevel: 2, category: 'Space' },
  { id: 'moon', type: 'avatar', name: 'Moon', emoji: '🌙', cost: 40, requiredLevel: 2, category: 'Space' },
  
  // Sports (Level 2+, 40 pts)
  { id: 'soccer', type: 'avatar', name: 'Soccer', emoji: '⚽', cost: 40, requiredLevel: 2, category: 'Sports' },
  { id: 'basketball', type: 'avatar', name: 'Basketball', emoji: '🏀', cost: 40, requiredLevel: 2, category: 'Sports' },
  { id: 'trophy', type: 'avatar', name: 'Trophy', emoji: '🏆', cost: 40, requiredLevel: 2, category: 'Sports' },
  { id: 'medal', type: 'avatar', name: 'Medal', emoji: '🥇', cost: 40, requiredLevel: 2, category: 'Sports' },
  
  // Fantasy (Level 3+, 60 pts)
  { id: 'dragon', type: 'avatar', name: 'Dragon', emoji: '🐉', cost: 60, requiredLevel: 3, category: 'Fantasy' },
  { id: 'wizard', type: 'avatar', name: 'Wizard', emoji: '🧙', cost: 60, requiredLevel: 3, category: 'Fantasy' },
  { id: 'fairy', type: 'avatar', name: 'Fairy', emoji: '🧚', cost: 60, requiredLevel: 3, category: 'Fantasy' },
  { id: 'knight', type: 'avatar', name: 'Knight', emoji: '🤺', cost: 60, requiredLevel: 3, category: 'Fantasy' },
  
  // Champion (Level 5+, 100 pts)
  { id: 'crown', type: 'avatar', name: 'Crown', emoji: '👑', cost: 100, requiredLevel: 5, category: 'Champion' },
  { id: 'champion', type: 'avatar', name: 'Champion', emoji: '🏅', cost: 100, requiredLevel: 5, category: 'Champion' },
  { id: 'superstar', type: 'avatar', name: 'Superstar', emoji: '🌟', cost: 100, requiredLevel: 5, category: 'Champion' },
];

// =============================================
// GOAL THEMES (Frame/border effects only)
// =============================================
export const GOAL_THEMES: ShopItem[] = [
  { 
    id: 'default', 
    type: 'goal_theme', 
    name: 'Default', 
    description: 'Standard goal card',
    cost: 0, 
    requiredLevel: 0,
    preview: 'goal-theme-default'
  },
  { 
    id: 'gradient-glow', 
    type: 'goal_theme', 
    name: 'Gradient Glow', 
    description: 'Soft glowing border effect',
    cost: 30, 
    requiredLevel: 1,
    preview: 'goal-theme-gradient-glow'
  },
  { 
    id: 'neon', 
    type: 'goal_theme', 
    name: 'Neon Frame', 
    description: 'Bright neon outline',
    cost: 40, 
    requiredLevel: 2,
    preview: 'goal-theme-neon'
  },
  { 
    id: 'nature', 
    type: 'goal_theme', 
    name: 'Nature', 
    description: 'Green earthy border',
    cost: 40, 
    requiredLevel: 2,
    preview: 'goal-theme-nature'
  },
  { 
    id: 'galaxy', 
    type: 'goal_theme', 
    name: 'Galaxy', 
    description: 'Purple/blue starry glow',
    cost: 60, 
    requiredLevel: 3,
    preview: 'goal-theme-galaxy'
  },
  { 
    id: 'royal', 
    type: 'goal_theme', 
    name: 'Royal', 
    description: 'Gold ornate border',
    cost: 80, 
    requiredLevel: 4,
    preview: 'goal-theme-royal'
  },
  { 
    id: 'rainbow', 
    type: 'goal_theme', 
    name: 'Rainbow', 
    description: 'Animated rainbow border',
    cost: 100, 
    requiredLevel: 5,
    preview: 'goal-theme-rainbow'
  },
];

// =============================================
// POWER-UPS
// =============================================
export const POWER_UPS: ShopItem[] = [
  { 
    id: 'spotlight', 
    type: 'power_up', 
    name: 'Spotlight', 
    description: 'Highlight a goal for 7 days - pins to top with golden glow',
    cost: 25, 
    requiredLevel: 1,
  },
];

// =============================================
// CERTIFICATE TEMPLATES (Level-gated, not purchasable)
// =============================================
export interface CertificateTemplateConfig {
  id: string;
  name: string;
  requiredLevel: number;
}

export const CERTIFICATE_TEMPLATES: CertificateTemplateConfig[] = [
  { id: 'professional', name: 'Professional', requiredLevel: 0 },
  { id: 'playful', name: 'Playful', requiredLevel: 0 },
  { id: 'kids', name: 'Kids Fun', requiredLevel: 0 },
  { id: 'inspiring', name: 'Inspiring', requiredLevel: 2 },
  { id: 'elegant', name: 'Elegant', requiredLevel: 3 },
  { id: 'modern', name: 'Modern', requiredLevel: 3 },
  { id: 'academic', name: 'Academic', requiredLevel: 4 },
  { id: 'achievement', name: 'Achievement', requiredLevel: 5 },
];

// =============================================
// LEVEL UNLOCK DESCRIPTIONS
// =============================================
export const LEVEL_UNLOCKS: Record<number, string[]> = {
  1: ['4 free starter avatars', '3 certificate templates', 'Default goal theme'],
  2: ['Space & Sports avatars', 'Neon & Nature themes', 'Inspiring certificate'],
  3: ['Fantasy avatars', 'Galaxy theme', 'Elegant & Modern certificates'],
  4: ['Royal theme', 'Academic certificate'],
  5: ['Rainbow theme', 'Achievement certificate', 'Champion avatars'],
  6: ['Prestige badge'],
};

// =============================================
// HELPER FUNCTIONS
// =============================================
export const getAvatarByEmoji = (emoji: string): ShopItem | undefined => {
  return PREMIUM_AVATARS.find(a => a.emoji === emoji);
};

export const isAvatarFree = (emoji: string): boolean => {
  return FREE_AVATARS.includes(emoji);
};

export const getThemeById = (themeId: string): ShopItem | undefined => {
  return GOAL_THEMES.find(t => t.id === themeId);
};

export const getCertificateTemplateConfig = (templateId: string): CertificateTemplateConfig | undefined => {
  return CERTIFICATE_TEMPLATES.find(t => t.id === templateId);
};
